import { inject, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationStart, Router } from '@angular/router';
import { filter, map } from 'rxjs';

const getTabIndex = (tabLinks: readonly string[], url: string): number => {
  const [path] = url.split(/[?#]/);
  const segments = path.replace(/\(.*?\)/g, '').split('/');

  return tabLinks.findIndex((tabLink) => segments.includes(tabLink));
};

// Positive when the next tab is further right than the current one, negative when it is further left, and 0 when either
// URL is not a tab of the patient page (opening the patient, switching patient): the content only crossfades.
export const getTabSlideDirection = (tabLinks: readonly string[], currentUrl: string, nextUrl: string): number => {
  const currentIndex = getTabIndex(tabLinks, currentUrl);
  const nextIndex = getTabIndex(tabLinks, nextUrl);

  return currentIndex < 0 || nextIndex < 0 ? 0 : nextIndex - currentIndex;
};

// The router still holds the current URL when a navigation starts, so both ends of the tab switch are known.
export const injectTabSlideDirection = (tabLinks: readonly string[]): Signal<number> => {
  const router = inject(Router);

  return toSignal(
    router.events.pipe(
      filter((event): event is NavigationStart => event instanceof NavigationStart),
      map(({ url }) => getTabSlideDirection(tabLinks, router.url, url)),
    ),
    { initialValue: 0 },
  );
};
